import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { DataCollection } from '../models/site-content/data-collection.model';
import { CurrentSiteService } from '../services/current-site.service';
import { DataCollectionService } from '../services/data-collection.service';
import { CommunicationService } from '../services/communication.service';

@Injectable()
export class DataCollectionResolver implements Resolve<DataCollection> {
    constructor(
        private dataCollectionService: DataCollectionService,
        private currentSiteService: CurrentSiteService,
        private communicationService: CommunicationService,
        private router: Router) { }

    // The resolve method here acts as a guard.
    // A route guard wouldn't work because route guards get fired _before_ resolvers
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DataCollection> {
        this.communicationService.UpdateAsyncFormInstanceLoadingMessage("BEFORE: Getting site data from the server...5%");
        let id = route.params['id'];
        // If the current site has already been set, just return it without going to the server
        if (this.currentSiteService.isCurrentSite(id)) {
            return new Promise((resolve, reject) => {
                return resolve(this.currentSiteService.Site)
            })
        } else {
            // 06-10-2025 change:  changed the call to the server to a resolver-specific
            //                     endpoint that returns only the data needed by the app.
            //return this.dataCollectionService.get(id).then(site => {
            return this.dataCollectionService.findForResolver(id).then(site => {
                if (site && site.id > 0) {
                    this.currentSiteService.Site = site;
                    return this.currentSiteService.Site;
                } else {
                    this.router.navigate(['/404'], { skipLocationChange: true });
                    return null;
                }
            });
        }
    }
}
